import { CART_ADD_ITEM, CART_REMOVE_ITEM, CART_SAVE_PAYMENT_METHOD, CART_SAVE_SHIPPING_ADDRESS } from '../constants/cartConstants'
import axios from 'axios'
import { BASE_URL } from '../constants/urlConstants'
export const addToCart = (id, qty) => async (dispatch, getState) => {

    const { data } = await axios.get(`${BASE_URL}/products/${id}`)

    dispatch({
        type: CART_ADD_ITEM,
        payload: {
            product: data._id,
            name: data.name,
            image: data.image,
            price: data.price,
            countInStock: data.countInStock,
            qty
        }
    })

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}


//اینجا async لازم نداریم چون نمیخواهیم چیزی از دیتابیس بگیریم
//اما چون باید localstorage به روز شود باز هم به تانک نیاز داریم

export const removeFromCart = (id) => (dispatch, getState) => {


    dispatch({
        type: CART_REMOVE_ITEM,
        payload: id
    })

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}

export const saveShippingAddress = (data) => (dispatch, getState) => {
    dispatch({ type: CART_SAVE_SHIPPING_ADDRESS, payload: data })
    localStorage.setItem('shippingAdress', JSON.stringify(data))
}

export const savePaymentMethod =(data) => (dispatch) =>{
    dispatch({type:CART_SAVE_PAYMENT_METHOD, payload:data})
    localStorage.setItem('paymentMethod',JSON.stringify(data))
}